module.exports = __webpack_public_path__ + "static/media/teacherSideReport.2d728aa0.svg";